import { useEffect, useState } from 'react';

const useEntryPage = () => {
  const [entryPage, setEntryPage] = useState(null);
  const [leadTypeLockBranchOrSalesman, setLeadTypeLockBranchOrSalesman] = useState(null);

  useEffect(() => {
    // Get entry page and source lead type from session storage
    const entryPageFromSessionStorage = sessionStorage.getItem('entryPage')
      ? JSON.parse(sessionStorage.getItem('entryPage'))
      : null;

    const leadTypeLockBranchOrSalesmanFromSessionStorage = sessionStorage.getItem(
      'leadTypeLockBranchOrSalesman'
    )
      ? JSON.parse(sessionStorage.getItem('leadTypeLockBranchOrSalesman'))
      : null;

    // set to state
    setEntryPage(entryPageFromSessionStorage);
    setLeadTypeLockBranchOrSalesman(leadTypeLockBranchOrSalesmanFromSessionStorage);
  }, []);

  // Save entry page
  const saveEntryPage = (entryPageValue) => {
    const isEntryPageExist = sessionStorage.getItem('entryPage') ? true : false;

    if (!isEntryPageExist) {
      sessionStorage.setItem('entryPage', JSON.stringify(entryPageValue));
      setEntryPage(entryPageValue);
    }
  };

  // Save source lead type if entry page null (set lead type if user visit the page in the first time)
  const saveLeadTypeLockBranchOrSalesman = (leadType) => {
    const isEntryPageExist = sessionStorage.getItem('entryPage') ? true : false;

    if (!isEntryPageExist) {
      sessionStorage.setItem('leadTypeLockBranchOrSalesman', JSON.stringify(leadType));
      setLeadTypeLockBranchOrSalesman(leadType);
    }
  };

  return {
    entryPage,
    leadTypeLockBranchOrSalesman,
    saveEntryPage,
    saveLeadTypeLockBranchOrSalesman,
  };
};

export default useEntryPage;
